module.exports = __webpack_public_path__ + "img/delivery_engineer-bg.433b94eb.png";